import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatListModule } from "@angular/material/list";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { TranslocoModule } from "@jsverse/transloco";

import { LorenBottomSheetComponent } from "./components/loren-bottom-sheet/loren-bottom-sheet.component";

@NgModule({
  declarations: [LorenBottomSheetComponent],
  providers: [MatBottomSheet],
  imports: [
    CommonModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,

    TranslocoModule,
  ],
})
export class LorenBottomSheetModule {}
